import { render, staticRenderFns } from "./DroppingItemEmail.vue?vue&type=template&id=5943d684"
import script from "./DroppingItemEmail.vue?vue&type=script&lang=js"
export * from "./DroppingItemEmail.vue?vue&type=script&lang=js"
import style0 from "./DroppingItemEmail.vue?vue&type=style&index=0&id=5943d684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports